import { tzAxios } from 'api/axios';
import { HistoryResponse } from 'api/responseTypes';

export const getHistoryOrdersInfo = async () =>
  (await tzAxios.get<HistoryResponse>('/ticket-zone/ticket-orders')).data;
